import i18next from 'i18next';
import { getIPFAppName, getUserInitiatedFeedbackitem } from './util';
import { IFeedbackItem, feedbackItems } from './constants';

export const getInProductFeedbackMyAccountFeedbackItemSettings = (
  t: i18next.TranslationFunction,
  surveyName: string,
): IFeedbackItem => {
  const myaccountgeneric = 'myaccountgeneric';

  // here we default to user initiated feedbackItem if we are provided a surveyName that doesn't exist in our feedbackItems map
  const item = JSON.parse(JSON.stringify(feedbackItems[surveyName] ?? getUserInitiatedFeedbackitem(feedbackItems)));

  if (item.ces.enable) {
    item.ces.strings = {
      label: t((item.hasCustomLabel ? surveyName : myaccountgeneric) + 'CesLabel', { appName: getIPFAppName() }),
    };
  }
  if (item.cva.enable) {
    item.cva.strings = {
      label: t((item.hasCustomLabel ? surveyName : myaccountgeneric) + 'CvaLabel', { appName: getIPFAppName() }),
    };
  }
  if (item.csat.enable) {
    item.csat.strings = {
      label: t((item.hasCustomLabel ? surveyName : myaccountgeneric) + 'CsatLabel', { appName: getIPFAppName() }),
    };
  }

  return item;
};
